import type {
	AppEvent,
	EventPayloads,
	Listener
} from '@/types/event-emitter.types';

class EventEmitter {
	private static instance: EventEmitter;

	private listeners: {
		[K in AppEvent]?: Listener<K>[];
	} = {};

	private constructor() {}

	static getInstance(): EventEmitter {
		if (!EventEmitter.instance) {
			EventEmitter.instance = new EventEmitter();
		}
		return EventEmitter.instance;
	}

	on<K extends AppEvent>(event: K, listener: Listener<K>): () => void {
		const arr = this.listeners[event] ?? [];
		(this.listeners[event] as Listener<K>[]) = [...arr, listener];
		return () => {
			(this.listeners[event] as Listener<K>[]) = (
				this.listeners[event] as Listener<K>[]
			).filter((l) => l !== listener);
		};
	}

	emit<K extends AppEvent>(
		event: K
	): EventPayloads[K] extends void ? void : never;
	emit<K extends AppEvent>(
		event: K,
		payload: EventPayloads[K]
	): EventPayloads[K] extends void ? never : void;

	emit<K extends AppEvent>(event: K, payload?: EventPayloads[K]): void {
		(this.listeners[event] as Listener<K>[] | undefined)?.forEach(
			(listener) => {
				if (payload === undefined) {
					(listener as () => void)();
				} else {
					(listener as (arg: EventPayloads[K]) => void)(payload);
				}
			}
		);
	}
}

export const emitter = EventEmitter.getInstance();
